import { config, createTheme, css, ustaLightThemeConfig } from '@clubspark-react/ui/core';

import { getClientConfig } from 'config/clients';

const defaultThemeConfig = getClientConfig().defaultTheme === 'usta-light-theme' ? ustaLightThemeConfig : config?.theme;

export const themeV2 = createTheme(getClientConfig().defaultTheme || 'clubspark-light-theme', {
  ...defaultThemeConfig,
});

export const PillStatusColor = {
  open: config?.theme?.colors?.success70,
  close: config?.theme?.colors?.warning70,
  inprogress: config?.theme?.colors?.highlight100,
  completed: config?.theme?.colors?.coreGreys50,
  cancelled: config?.theme?.colors?.destructive100main,
};

export default css;
